import { useQuery } from "@apollo/client/react";
import { type ResultOf } from "gql.tada";
import { GET_REFERENCE_DATA } from "../graphql/queries";

export type Supplier = ResultOf<typeof GET_REFERENCE_DATA>["suppliers"][number];

interface UseSuppliersResult {
  suppliers: Supplier[];
  loading: boolean;
}

const useSuppliers = (): UseSuppliersResult => {
  const { data, loading } = useQuery(GET_REFERENCE_DATA);
  return {
    suppliers: [...(data?.suppliers ?? [])].sort((a, b) =>
      a.name.localeCompare(b.name),
    ),
    loading,
  };
};

export default useSuppliers;
